module.exports = __webpack_public_path__ + "images/video-animation-1263b689e5e9badabc5e4e8ccbd0b37c.svg";